import { useEffect, useState } from 'react';
import { nanoid } from 'nanoid';
import useErrors from 'hooks/useErrors';
import { contextPayment } from 'context';
import { useForm } from 'react-hook-form';
import { paymentService } from 'services';
import { convertToNumber } from 'helpers/utils';
import { useNavigate, useParams } from 'react-router-dom';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

const usePayment = ({ acceptanc = false, trans = false, defaultValues = {} } = {}) => {
 const { getContracts, acceptanceToken, createPayment, getTransaction } = paymentService.useApiPayments();
 const { contract, setContract, contracts, setContracts, setPayerDetails, payerDetails } = contextPayment();
 const navigate = useNavigate();
 const { setError } = useErrors();
 const { id } = useParams();
 const queryClient = useQueryClient();
 const [dataPay, setDataPay] = useState({});
 const [show, setShow] = useState(!acceptanc);
 const setPayment = useMutation(createPayment);
 const [isLoaded, setIsLoaded] = useState(false);
 const mutateContracts = useMutation(getContracts);
 const [transaction, setTransaction] = useState({});

 const { watch, getValues, register, setValue, reset, handleSubmit, formState } = useForm({
  defaultValues: { ...defaultValues, contract: id }
 });

 useQuery({
  queryKey: ['transaction'],
  queryFn: () => getTransaction(id),
  onSettled: () => setIsLoaded(false),
  onSuccess: payment => {
   console.log(payment, 'la transaccion');
   setContract(payment?.contract);
   setTransaction(payment?.transaction);
  },
  onError: () => {
   setContract({});
   setTransaction({});
  },
  enabled: trans && !!id
  //staleTime: Infinity
 });

 useQuery({
  queryKey: ['acceptanceToken'],
  queryFn: () => acceptanceToken(contract?.company),
  onSuccess: ({ data: { presigned_acceptance } }) => {
   setValue('acceptance_token', presigned_acceptance?.acceptance_token);
   setValue('permalink', presigned_acceptance?.permalink);
  },
  onSettled: () => setIsLoaded(false),
  onError: err => console.log(err),
  enabled: acceptanc && !!contract?.company,
  staleTime: Infinity
 });

 const setcontract = data => {
  setContract(data);
  navigate(`contract/${data?._id}`);
 };

 const handleClose = () => {
  setShow(false);
  navigate(-1);
 };

 const amountOwed = financing => {
  let paid = 0;
  const currentDate = new Date();

  const outstandingBalances = financing.filter(item => {
   const lastDate = new Date(item.lastDate);
   paid += convertToNumber(item.amount - item.balance);
   return lastDate <= currentDate && item.balance > 0;
  });

  const owed = outstandingBalances.reduce((add, item) => add + (item.balance + item.interest), 0);

  return { paid, owed };
 };

 const consultContractsByDoc = async data => {
  mutateContracts.mutate(data, {
   onSuccess: obj => {
    console.log(obj, 'los contratos');
    setPayerDetails(data);
    setContracts(
     obj.contracts.map(e => {
      const { owed, paid } = amountOwed(e.financing);
      return { ...e, owed, paid };
     })
    );
   },
   onSettled: () => setIsLoaded(false),
   onError: err => setError(err)
  });
 };

 const goNavigate = (transaction = null) => {
  if (transaction) {
   navigate(id ? location.pathname.replace(id, transaction) : transaction);
   queryClient.invalidateQueries(['transaction']);
  }
 };

 const navigat = (url, id = '') => {
  const pathname = new URL(url + id).pathname;
  return navigate(pathname);
 };

 const onSubmitData = async data => {
  setIsLoaded(true);
  //   console.log(data, 'antes de enviar');
  setPayment.mutate(data, {
   onSuccess: ({ id, redirect_url, payment_method: { extra } }) => {
    if (extra?.async_payment_url) return (window.location.href = extra?.async_payment_url);

    if (extra?.business_agreement_code) return setDataPay({ ...extra, id, redirect_url });

    navigat(redirect_url, id);
   },
   onSettled: () => {
    setIsLoaded(false);
    setValue('reference', contract?.company + '-' + nanoid());
    queryClient.invalidateQueries(['acceptanceToken']);
   },
   onError: err => setError(err)
  });
 };

 const onError = err => {
  console.log('se produjo un error ', err);
 };

 useEffect(() => {
  if (trans) return;
  console.log(contract, 'el contrato');

  if (!contract?._id && acceptanc) return navigat(`${location.origin}/payments`);

  const customer = contract?.receivers?.find(e => e.docType === payerDetails?.docType && e.docNumber === payerDetails?.docNumber);
  const { _id, arrayName, email, phone, docType, docNumber } = customer ?? {};
  const name = arrayName?.join(' ');
  const data = getValues();
  reset({
   ...data,
   customer: _id,
   customer_email: email,
   agent: contract?.agent,
   created_at: new Date(),
   company: contract?.company,
   business: contract?.business,
   reference: contract?.company + '-' + nanoid(),
   redirect_url: location.origin + '/payments/invoice/',
   customer_data: { 'legal-id': docNumber, 'legal-id-type': docType, full_name: name, email, phone_number: phone }
  });
 }, [contract]);

 /* useEffect(() => {
  const subscription = watch((value, { name }) => {
   if (name === undefined) return;
   console.log(value, 'el formulario cambio en ', name);
  });
  return () => subscription.unsubscribe();
 }, [watch]);
 */

 return {
  id,
  show,
  watch,
  onError,
  navigat,
  dataPay,
  setValue,
  register,
  contract,
  isLoaded,
  contracts,
  goNavigate,
  transaction,
  setcontract,
  handleClose,
  handleSubmit,
  onSubmitData,
  consultContractsByDoc,
  errors: formState.errors
 };
};

export default usePayment;
